import React from 'react';
import Text from '../Base/Text/Text';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';
import useNotification from '../../Hooks/useNotification.hook';
import useTranslation from '../../Hooks/useTranslation';
import { useValidation } from '../Utils/Validation';

export interface SubmitButtonProps<T extends FieldValues = FieldValues> {
	onSubmit: SubmitHandler<T>;
	disabled?: boolean;
	title?: string;
	className?: string;
}

const SubmitButton = <T extends FieldValues = FieldValues>(
	props: SubmitButtonProps<T>,
) => {
	const { onSubmit, title = 'base.create', className, disabled } = props;
	const { t } = useTranslation();
	const { messageFilled } = useValidation();

	const { showNotificationAlert } = useNotification();
	const methods = useFormContext<T>();

	const resolveErrorMessage = (error: any) => {
		if (!error) return;

		if (typeof error?.message !== 'undefined') {
			let errorMessage = t(error?.message?.toString());
			if (['is-required-select', 'required'].indexOf(error?.type) !== -1) {
				errorMessage = messageFilled(errorMessage || '');
			}
			if (errorMessage) {
				console.log('errorMessage', errorMessage);
				showNotificationAlert({
					content: t(errorMessage),
				});
			}
		} else {
			if (Array.isArray(error)) {
				for (let i = 0; i < error.length; i++) {
					resolveErrorMessage(error[i]);
				}
			} else {
				for (const key of Object.keys(error)) {
					resolveErrorMessage(error[key]);
				}
			}
		}
	};

	const handlePress = () => {
		if (disabled) return;

		const onValid: SubmitHandler<T> = values => {
			console.log('✅ Úspěšně validováno, hodnoty:', values);
			onSubmit(values);
		};

		const onInvalid = (errors: any) => {
			console.log('❌ Chyby validace:', errors);
			console.log('📋 Hodnoty při chybné validaci:', methods.getValues());
			for (const key in errors) resolveErrorMessage((errors as any)[key]);
		};

		methods.handleSubmit(onValid, onInvalid)();
	};

	return (
		<button
			className={className || 'btn btn-green-global remastered'}
			type='button'
			onClick={handlePress}
			disabled={disabled}>
			{title && <Text tx={title} inline={true} firstUpper={true} />}
		</button>
	);
};

export default SubmitButton;
